import { v7 as uuidv7 } from "uuid";
import { z } from "zod";

export const flagActionSchema = z.object({
  id: z.string().uuid(),
  quantityId: z.string().uuid(),
  flagColumnId: z.string().uuid(),
  flagRowId: z.string().uuid(),
  value: z.string().nullish(),
  modifiedValue: z.string().nullish(),
});

export const newFlagActionInputSchema = flagActionSchema.omit({
  id: true,
});

export const editFlagActionInputSchema = flagActionSchema.pick({
  value: true,
});

export type FlagAction = z.infer<typeof flagActionSchema>;
export type FlagActionInput = z.input<typeof flagActionSchema>;
export type NewFlagActionInput = z.input<typeof newFlagActionInputSchema>;

export const createFlagAction = (input: NewFlagActionInput): FlagAction => {
  return newFlagAction({
    ...input,
    id: uuidv7(),
  });
};

export const newFlagAction = (input: FlagActionInput): FlagAction => flagActionSchema.parse(input);
